import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

// const useDownloadPdf = () => {
//   const generatePdf = async (elementId, fileName = "download.pdf") => {
//     const input = document.getElementById(elementId);
//     if (!input) {
//       console.error(`Element with ID '${elementId}' not found.`);
//       return;
//     }

//     try {
//       const canvas = await html2canvas(input, {
//         scale: 2,
//         useCORS: true,
//       });

//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");

//       const imgProps = pdf.getImageProperties(imgData);
//       const pdfWidth = 210;
//       const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

//       const pageHeight = 297;
//       let remainingHeight = pdfHeight;
//       let position = 0;

//       while (remainingHeight > 0) {
//         pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
//         remainingHeight -= pageHeight;
//         if (remainingHeight > 0) {
//           pdf.addPage();
//           position = - (pdfHeight - remainingHeight);
//         }
//       }

//       pdf.save(fileName);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//     }
//   };

//   return { generatePdf };
// };
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";

const useDownloadPdf = () => {
  const generatePdf = async (elementId, fileName = "download.pdf") => {
    const input = document.getElementById(elementId);
    if (!input) {
      console.error(`Element with ID '${elementId}' not found.`);
      return;
    }
    try {
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
      });
      const imgWidth = 210; 
      const pageHeight = 297; 
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position -= pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return { generatePdf };
};

export default useDownloadPdf;
